import { styled } from "../../../../styles/stitches.config"

export default styled("div", {
  display: "flex",
  flexDirection: "column",

  ellipsis: {},
})
